import { Link } from "react-router-dom";

export default function CGV() {
  return (
    <main style={{ paddingTop: "80px", backgroundColor: "#F7F3EA", minHeight: "100vh" }}>

      {/* En-tête */}
      <section style={{ padding: "80px 40px 60px", borderBottom: "1px solid rgba(61,22,2,0.08)" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "9px", letterSpacing: "5px", textTransform: "uppercase", color: "rgba(61,22,2,0.4)", marginBottom: "20px" }}>
            Mentions légales
          </p>
          <h1 style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontSize: "clamp(2rem, 4vw, 3rem)", fontWeight: "300", color: "#3D1602", lineHeight: "1.15", letterSpacing: "-0.02em" }}>
            Conditions Générales de Vente
          </h1>
        </div>
      </section>

      {/* Contenu */}
      <section style={{ padding: "64px 40px 100px" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>

          <Article num="1" title="Identification de l'entreprise">
            <Table rows={[
              ["Nom de l'entreprise", "Laurine ALEXANDRE-ALEXIS"],
              ["Statut juridique", "Auto-entrepreneur"],
              ["Siège social", "10 RUE DE LA PIERRE AUX MOINES – 92360"],
              ["E-mail", <a href="mailto:ellaa.wedding@gmail.com" style={{ color: "#3D1602" }}>ellaa.wedding@gmail.com</a>],
              ["Téléphone", "07 83 60 03 28"],
            ]} />
            <P>L'ensemble des règles édictées par les présentes conditions générales de vente (CGV) ont pour but de garantir une collaboration et des relations de travail saines. Elles sont également là pour protéger chacune des parties en cas d'imprévu.</P>
            <P>En cas de refus d'acceptation des présentes conditions générales de vente, aucune relation professionnelle ne sera envisageable, à l'inverse tout acte d'achat au sein de l'entreprise représente une marque d'acceptation pleine et entière des présentes.</P>
          </Article>

          <Article num="2" title="Objet">
            <P>Les présentes Conditions Générales de Vente ont pour objet de définir les modalités selon lesquelles Laurine ALEXANDRE-ALEXIS propose des prestations de conseil, d'organisation et/ou de coordination d'événements privés, et notamment de mariages, à ses clients particuliers.</P>
            <P>Toute commande passée à Laurine ALEXANDRE-ALEXIS implique l'adhésion entière et sans réserve du client aux présentes conditions.</P>
          </Article>

          <Article num="3" title="Prestations proposées">
            <P>Ellaa Wedding propose différents types de prestations :</P>
            <ul style={ulStyle}>
              {["Organisation complète de mariage", "Organisation partielle", "Coordination du Jour J", "Prestations de conseil ou d'accompagnement ponctuel"].map((item, i) => <Li key={i}>{item}</Li>)}
            </ul>
            <P>Le détail de chaque prestation est précisé dans le devis et le contrat signé entre les deux parties.</P>
          </Article>

          <Article num="4" title="Devis et contrat">
            <P>Toute prestation donne lieu à l'établissement d'un devis détaillé valable 30 jours à compter de sa date d'émission.</P>
            <P>La prestation ne sera considérée comme définitivement validée qu'après :</P>
            <ul style={ulStyle}>
              <Li>Signature du contrat par les deux parties,</Li>
              <Li>Et versement du premier acompte prévu au contrat.</Li>
            </ul>
            <P>À défaut de retour du contrat signé et du règlement de l'acompte dans les délais, la date réservée sera automatiquement libérée.</P>
          </Article>

          <Article num="5" title="Tarifs et modalités de paiement">
            <P>Les tarifs sont exprimés en euros, hors frais éventuels de déplacement ou de sous-traitance, qui feront l'objet d'une mention spécifique dans le devis.</P>
            <P>Le règlement s'effectue selon les modalités suivantes (sauf indication contraire dans le contrat) :</P>
            <ul style={ulStyle}>
              <Li>30 % d'acompte à la signature du contrat,</Li>
              <Li>40 % à mi-parcours ou selon le calendrier convenu,</Li>
              <Li>30 % de solde au plus tard 1 semaine avant l'événement.</Li>
            </ul>
            <P>Tout retard de paiement donnera lieu, sans mise en demeure préalable, à l'application d'une indemnité forfaitaire de 40 € pour frais de recouvrement, conformément à l'article L441-10 du Code de commerce.</P>
          </Article>

          <Article num="6" title="Droit de rétractation">
            <P>Conformément à l'article L221-18 du Code de la consommation, en cas de signature du contrat hors établissement (domicile du client, salon, etc.), le client dispose d'un délai de rétractation de 14 jours à compter de la signature.</P>
            <P>Toute prestation commencée avant la fin du délai de rétractation, à la demande expresse du client, entraîne la renonciation à ce droit.</P>
          </Article>

          <Article num="7" title="Annulation et report">
            <P>Toute annulation de la part du client doit être notifiée par écrit (courrier ou e-mail).</P>
            <ul style={ulStyle}>
              <Li>Annulation à plus de 6 mois avant l'événement : l'acompte reste acquis à Laurine ALEXANDRE-ALEXIS.</Li>
              <Li>Annulation entre 6 mois et 3 mois avant l'événement : 50 % du montant total sera dû.</Li>
              <Li>Annulation à moins de 3 mois : la totalité de la prestation sera due.</Li>
            </ul>
            <P>En cas de report de date, Ellaa Wedding / Laurine ALEXANDRE-ALEXIS fera son possible pour s'adapter, sous réserve de disponibilité à la nouvelle date.</P>
          </Article>

          <Article num="8" title="Obligations du prestataire">
            <P>Laurine ALEXANDRE-ALEXIS s'engage à :</P>
            <ul style={ulStyle}>
              <Li>Fournir les prestations décrites au contrat,</Li>
              <Li>Agir en professionnel diligent,</Li>
              <Li>Informer le client régulièrement de l'avancée de l'organisation.</Li>
            </ul>
            <P>Laurine ALEXANDRE-ALEXIS ne saurait être tenue pour responsable des éventuelles défaillances des prestataires tiers choisis par le client, ni des conséquences liées à des cas de force majeure (intempéries, grèves, pandémies, etc.).</P>
          </Article>

          <Article num="9" title="Obligations du client">
            <P>Le client s'engage à :</P>
            <ul style={ulStyle}>
              <Li>Fournir toutes les informations nécessaires à la bonne réalisation de la prestation,</Li>
              <Li>Respecter les délais de paiement convenus,</Li>
              <Li>Souscrire, le cas échéant, une assurance responsabilité civile pour l'événement.</Li>
            </ul>
          </Article>

          <Article num="10" title="Assurance">
            <P>ALEXANDRE-ALEXIS Laurine est couverte par une responsabilité civile professionnelle.</P>
            <P>Il appartient au client de souscrire une assurance spécifique pour l'événement (dommages matériels, corporels ou autres incidents).</P>
          </Article>

          <Article num="11" title="Droit à l'image">
            <P>Sauf opposition écrite du client, Laurine ALEXANDRE-ALEXIS réserve le droit d'utiliser des photos et vidéos prises lors de l'événement à des fins de communication (site internet, réseaux sociaux, supports commerciaux).</P>
          </Article>

          <Article num="12" title="Confidentialité">
            <P>Afin de gérer pleinement le dossier client et la réalisation de la prestation, le prestataire est amené à collecter un certain nombre de données y compris personnelles, notamment : nom, prénom, adresse, téléphone, mail…</P>
            <P>Ces données sont des données personnelles au sens du règlement général de protection des données (RGPD). Le client dispose donc d'un droit à toute rectification, du droit à l'oubli, à l'opposition, la portabilité, l'effacement et la limitation de traitement de ses données.</P>
            <P>Les données ne seront utilisées qu'à des fins professionnelles (suivi de prestation, envoi de newsletter, facturation et comptabilité, établissement d'un contrat…). Les données du client sont conservées pendant 3 ans maximum à compter du dernier échange avec le prestataire.</P>
            <P>Le client peut réaliser toute réclamation amiable à l'adresse mail : <a href="mailto:ellaa.wedding@gmail.com" style={{ color: "#3D1602" }}>ellaa.wedding@gmail.com</a> ou en cas de différend, auprès de la CNIL.</P>
            <p style={{ fontSize: "11px", color: "rgba(61,22,2,0.45)", fontStyle: "italic", marginTop: "12px", lineHeight: "1.7" }}>
              * Loi « Informatique et liberté » du 6 janvier 1978 modifiée et au RGPD n°2016/679/UE du 27 avril 2016, en vigueur depuis le 25 mai 2018.
            </p>
          </Article>

          <Article num="13" title="Propriété intellectuelle">
            <P>Les créations, documents, visuels et supports remis au client par Laurine ALEXANDRE-ALEXIS restent la propriété intellectuelle de celle-ci.</P>
            <P>Toute reproduction ou diffusion sans autorisation écrite est strictement interdite.</P>
          </Article>

          <Article num="14" title="Réclamations et litiges">
            <P>Si l'une des parties ne respecte pas ses obligations, l'autre partie doit lui écrire dès qu'elle en prend connaissance. L'autre partie aura 7 jours pour se conformer à ses obligations. À défaut, l'autre partie peut refuser librement d'exécuter ses propres obligations.</P>
            <P>Pour tout désaccord ou litige, vous pouvez contacter le prestataire par mail à l'adresse <a href="mailto:ellaa.wedding@gmail.com" style={{ color: "#3D1602" }}>ellaa.wedding@gmail.com</a> dans le but de trouver une solution amiable.</P>
            <P>Si aucune solution amiable n'est trouvée au bout d'un mois, la partie la plus diligente pourra saisir le Tribunal compétent.</P>
          </Article>

          <Article num="15" title="Acceptation des CGV" last={true}>
            <P>La signature du contrat de prestation vaut acceptation pleine et entière des présentes Conditions Générales de Vente.</P>
          </Article>

          {/* Retour */}
          <div style={{ marginTop: "48px" }}>
            <Link to="/" style={{ fontFamily: "'Inter', sans-serif", fontSize: "10px", letterSpacing: "3px", textTransform: "uppercase", color: "#3D1602", textDecoration: "none", borderBottom: "1px solid rgba(61,22,2,0.4)", paddingBottom: "2px" }}>
              ← Retour à l'accueil
            </Link>
          </div>

        </div>
      </section>
    </main>
  );
}

/* ── Composants internes ── */

const ulStyle = { paddingLeft: "0", margin: "12px 0 16px", listStyle: "none" };

function Article({ num, title, children, last }) {
  return (
    <div style={{ marginBottom: last ? 0 : "48px", paddingBottom: last ? 0 : "48px", borderBottom: last ? "none" : "1px solid rgba(61,22,2,0.07)" }}>
      <h2 style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontSize: "1.15rem", fontWeight: "400", color: "#3D1602", marginBottom: "20px", letterSpacing: "-0.01em" }}>
        Article {num}. {title}
      </h2>
      {children}
    </div>
  );
}

function P({ children }) {
  return <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "13px", lineHeight: "1.9", color: "rgba(61,22,2,0.7)", fontWeight: "300", marginBottom: "12px" }}>{children}</p>;
}

function Li({ children }) {
  return (
    <li style={{ fontFamily: "'Inter', sans-serif", fontSize: "13px", lineHeight: "1.9", color: "rgba(61,22,2,0.7)", fontWeight: "300", paddingLeft: "16px", position: "relative", marginBottom: "4px" }}>
      <span style={{ position: "absolute", left: 0, color: "rgba(61,22,2,0.3)" }}>–</span>
      {children}
    </li>
  );
}

function Table({ rows }) {
  return (
    <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px", fontSize: "13px" }}>
      <tbody>
        {rows.map(([label, val], i) => (
          <tr key={i} style={{ borderBottom: "1px solid rgba(61,22,2,0.06)" }}>
            <td style={{ padding: "10px 16px 10px 0", fontFamily: "'Inter', sans-serif", fontSize: "10px", letterSpacing: "2px", textTransform: "uppercase", color: "rgba(61,22,2,0.45)", fontWeight: "500", width: "180px", whiteSpace: "nowrap" }}>{label}</td>
            <td style={{ padding: "10px 0", fontFamily: "'Inter', sans-serif", fontSize: "13px", color: "rgba(61,22,2,0.75)", fontWeight: "300" }}>{val}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
